import React from 'react';
import { Link } from 'react-router-dom';

/**
 * DashboardHeader
 *
 * Top gradient header for the dashboard with title and back-to-home link.
 */
const DashboardHeader = () => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-800 dark:to-purple-800 text-white p-6 rounded-lg">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold mb-2">IAC Benchmark Processing Dashboard</h1>
          <p className="text-lg opacity-90">
            Industrial Assessment Center Energy Efficiency Analysis
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/"
            className="bg-white bg-opacity-20 text-white px-4 py-2 rounded-lg hover:bg-opacity-30 transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;


